const { 
  ENVIRONMENT, 
  REACT_APP_HOST_URL, 
  REACT_APP_MSFT_APPID, 
  REACT_APP_REST_API_URL, 
  REACT_APP_BNG_PLAN_CLIENT, 
  REACT_APP_DS_AUTOMATION_ENABLED,
} = process.env


export const config = {
  api: REACT_APP_HOST_URL,
  environment: ENVIRONMENT,
  subscriptionApi: `${REACT_APP_HOST_URL}/subscription`,
  graphql: `${REACT_APP_HOST_URL}/graphql`,
  restEndpoint: REACT_APP_REST_API_URL || REACT_APP_HOST_URL || '',
  appId: REACT_APP_MSFT_APPID!,
  redirectUri: '/blank.html',
  // redirectUri: 'http://localhost:3005/',
  scopes: [
    `api://${REACT_APP_MSFT_APPID}/default`,
    'user.read',
    'mailboxsettings.read',
    'calendars.readwrite',
  ],
  bngPlanClient: REACT_APP_BNG_PLAN_CLIENT || '',
  dsAutomationEnabled: REACT_APP_DS_AUTOMATION_ENABLED === 'true',
  // rest: REST_ENDPOINT || '',
}
